import { render, staticRenderFns } from "./ConfirmDialogDemo.vue?vue&type=template&id=51b971c6"
import script from "./ConfirmDialogDemo.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports